enum PagesUrl {
  SerpTours = 'search',
  SerpHot = 'tury',
  SerpHotels = 'hotels/search',
  SerpRailway = 'railways/search',
}

export { PagesUrl };
